<div class="row mt-5">
    <div class="col-12 text-center">
        <h1>Atenção</h1>
    </div>

    <div class="col-12 d-flex justify-content-center mt-5 mb-5">
        <div class="img-feedback img-feedback-error"></div>
    </div>

    <!-- <div class="col-12 text-center mb-5">
        <p>Transação recusada por alguma restrição. Confira os dados 
            informados e tente novamente.</p>
    </div> -->

    <div class="col-12 text-center">
        <p>
            Neste momento, não temos uma proposta para você nesta forma de pagamento.

            Isso não quer dizer que tenha algo errado com o seu cadastro ou perfil, provavelmente, é mais ligado à
            política interna do SEMEAR.

            No entanto, esta situação pode mudar. Então, não deixe de tentar esta forma de pagamento na sua próxima
            compra.
        </p>
    </div>

</div>

<div class="row fixed-bottom">
    <div class="col-12 text-center">
        <button class="btn btn-primary" (click)="close()">Entendi</button>
    </div>
</div>